import { useEffect, useState } from "react";
import { ContainerFlex } from "../../../Components/Layout";
import useCategory from "../../../Hooks/Support/useCategory";
// import Filters from "./Filters";
import List from "./List";
import CategoryModal from "./Modal";
const Category = () => {
  const { indexCategory } = useCategory();

  const [reload, setReload] = useState(true);

  const handleReload = () => {
    setReload(!reload);
  };

  useEffect(() => {
    indexCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <ContainerFlex full padding="3">
      {/* <Filters /> */}
      <List setReload={handleReload} />
      <CategoryModal setReload={handleReload} />
    </ContainerFlex>
  );
};

export default Category;
